import { render, staticRenderFns } from "./SolutionCard.vue?vue&type=template&id=cdb2c76a&"
import script from "./SolutionCard.vue?vue&type=script&lang=js&"
export * from "./SolutionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports